import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  base: {
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    boxShadow: `0 0 0 1px ${theme.palette.grey[700]} inset`,

    '&:hover': {
      boxShadow: `0 0 0 1px ${theme.palette.text.primary} inset`,
    },
  },
  focus: {
    boxShadow: `0 0 0 2px ${theme.palette.primary.main} inset`,

    '&:hover': {
      boxShadow: `0 0 0 2px ${theme.palette.primary.main} inset`,
    },
  },
  error: {
    boxShadow: `0 0 0 1px ${theme.palette.error.main} inset`,

    '&:hover': {
      boxShadow: `0 0 0 1px ${theme.palette.error.main} inset`,
    },
  },
}));
